import { render } from "./SecurityBanner.vue?vue&type=template&id=2ece5046&scoped=true"
import script from "./SecurityBanner.vue?vue&type=script&lang=js"
export * from "./SecurityBanner.vue?vue&type=script&lang=js"

import "./SecurityBanner.vue?vue&type=style&index=0&id=2ece5046&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ece5046"]])

export default __exports__